export default __webpack_public_path__ + "static/media/player_3_eliminated.e8377e21.png";